import { Button, makeStyles } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import styles from '../Parceiros.style';
import { INITIAL_FILTER_STATE } from '../ParceirosTableConstants';

const useStyles = makeStyles(styles);

export const ParceirosParametrosHeader = props => {
  const { handleDownloadInvoices, filters, setFilters, setParcelasFilter, parcelasFilter } = props;
  const classes = useStyles(props);

  const hasMainFilters = Object.values(filters).filter(fil => fil != null).length > 0;

  const hasParcelasFilter = parcelasFilter && parcelasFilter !== '';

  const clearFiltersDisabled = !hasMainFilters && !hasParcelasFilter;

  const clearFilters = () => {
    setFilters(INITIAL_FILTER_STATE);
    setParcelasFilter('');
  };

  return (
    <TableHeader.Header>
      <TableHeader.Header.Title>Busca & Filtros</TableHeader.Header.Title>
      <TableHeader.OptionsLeft>
        <TableHeader.Input>
          <Button
            color="primary"
            className={classes.buttonClearFilter}
            disabled={clearFiltersDisabled}
            onClick={clearFilters}
          >
            LIMPAR FILTROS
          </Button>
          <Button color="primary" onClick={handleDownloadInvoices} variant="contained" startIcon={<GetApp />}>
            BAIXAR PLANILHA
          </Button>
        </TableHeader.Input>
      </TableHeader.OptionsLeft>
    </TableHeader.Header>
  );
};

ParceirosParametrosHeader.propTypes = {
  handleDownloadInvoices: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    partner: PropTypes.string,
    status: PropTypes.string,
    referenceDate: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
};
